import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import pkgJson from '../../package.json';
import wordmarkStacked from '@/assets/logo/wordmark-stacked.svg';

export function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-6 py-6 px-4" data-testid="about-page">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          data-testid="back-button"
          className="flex items-center justify-center -ml-1 p-1 rounded text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)] transition-colors"
        >
          <ChevronLeft size={20} />
        </button>
        <h1 className="font-display text-display-sm text-[var(--color-text-display)]">About Ridgen</h1>
      </div>
      <div className="flex flex-col items-center gap-3">
        <img src={wordmarkStacked} alt="Ridgen" className="h-16 w-auto" />
        <p className="text-body-sm text-[var(--color-text-muted)]">Know your land. Own your hunt.</p>
      </div>
      <div className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-xl p-5 flex flex-col gap-2">
        <p className="text-body-sm text-[var(--color-text-muted)]">Version</p>
        <p className="font-display text-display-sm text-[var(--color-text-primary)]">{pkgJson.version}</p>
      </div>
      <p className="text-body-sm text-[var(--color-text-placeholder)]">
        Ridgen helps whitetail hunters on private land manage prep tasks, scouting logs, and season
        planning — all offline-first.
      </p>
    </div>
  );
}
